import { restApi } from '../../api';
import {
  AdminHighlightOutput,
  CreateHighlightInput,
  HighlightOutput,
  UpdateHighlightInput,
} from './highlights.types';

const PATH = 'highlights';

export const findLatestHighlights = (limit: number) =>
  restApi.get<HighlightOutput[]>(`${PATH}/latest`, { limit });

export const findHighlights = () => restApi.get<AdminHighlightOutput[]>(PATH);

export const getHighlightById = (highlightId: string) =>
  restApi.get<HighlightOutput>(`${PATH}/${highlightId}`);

export const createHighlight = (input: CreateHighlightInput) =>
  restApi.post<HighlightOutput>(PATH, input);

export const updateHighlight = (highlightId: string, input: UpdateHighlightInput) =>
  restApi.patch<HighlightOutput>(`${PATH}/${highlightId}`, input);

export const deleteHighlight = (highlightId: string) => restApi.delete(`${PATH}/${highlightId}`);
